/**
 * ReportsHarvestInspectionAverageSize
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionValue } from '../../services/reportsHarvestInspections/selectors';

interface Props {
    averageSize?: ?number;
}

export class ReportsHarvestInspectionAverageSize extends React.PureComponent<Props> {
    render() {
        const { averageSize } = this.props;
        if (!averageSize && averageSize !== 0) return null;
        return averageSize;
    }
}

const mapStateToProps = createStructuredSelector({
    averageSize: makeSelectReportsHarvestInspectionValue('averageSize')
});

export default connect(mapStateToProps)(ReportsHarvestInspectionAverageSize);
